module.exports = __webpack_public_path__ + "img/2010-1.d080e965.jpg";